export default __webpack_public_path__ + "static/media/demo_ultrasound.4bb783eb.jpg";